export function injectScriptOnce(opts: {
    id: string;
    src: string;
    attrs?: Record<string, string>;
    before?: 'head' | 'body' | 'head-prepend';
}): Promise<void> {
    return new Promise((resolve, reject) => {
        const existing = document.getElementById(opts.id) as HTMLScriptElement | null;
        if (existing) {
            if (existing.getAttribute('data-loaded') === '1') return resolve();
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () => reject(new Error(`Script ${opts.id} failed`)));
            return;
        }

        const s = document.createElement('script');
        s.id = opts.id;
        s.src = opts.src;
        s.async = true;
        if (opts.attrs) {
            for (const [k, v] of Object.entries(opts.attrs)) s.setAttribute(k, String(v));
        }
        s.addEventListener('load', () => {
            s.setAttribute('data-loaded', '1');
            resolve();
        });
        s.addEventListener('error', () => reject(new Error(`Script ${opts.id} failed`)));

        const head = document.head;
        const body = document.body;
        if (opts.before === 'head-prepend') head.prepend(s);
        else if (opts.before === 'body') body.appendChild(s);
        else head.appendChild(s);
    });
}

export function deepEqual(a: any, b: any) {
    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch {
        return false;
    }
}
